import 'element-ui/lib/theme-chalk/index.css';
import '@/styles/elementUi.css'
import Vue from 'vue';
import {
	Menu,
	MenuItem,
	MenuItemGroup,
	Dropdown,
	DropdownItem,
	DropdownMenu,
	Submenu,
	Breadcrumb,
	BreadcrumbItem,
	Button,
    Dialog,
    Form,
	FormItem,
    Input,
    Select,
    Option,
    Image,
    Upload,
	Pagination,
    Tree,
    Popover,
    Tabs,
    TabPane,
    DatePicker,
    RadioGroup,
    Radio,
    Checkbox,
    CheckboxGroup,
    Link,
    InputNumber,
} from 'element-ui';

Vue.use(Menu);
Vue.use(Submenu);
Vue.use(MenuItemGroup);
Vue.use(MenuItem);
Vue.use(Dropdown);
Vue.use(DropdownItem);
Vue.use(DropdownMenu);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Button);
Vue.use(Dialog);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(Select);
Vue.use(Option);
Vue.use(Image);
Vue.use(Upload);
Vue.use(Pagination)
Vue.use(Tree);
Vue.use(Popover)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(DatePicker)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Link)
Vue.use(InputNumber)